import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { Outgo } from 'types';
import DEFAULT_OPTION from './default_option';

type OutgosResponse = {
  outgos: Outgo[];
};

type OutgoResponse = {
  outgo: Outgo;
};

type EmptyResponse = Record<string, never>;

const getOutgosWithParams = async (
  year: number,
  month: number,
): Promise<OutgosResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    searchParams: { year, month },
    throwHttpErrors: true,
  };

  const response = await ky.get('outgos', options);

  return response.json();
};

export const getOutgos = async (
  year: number | null = null,
  month: number | null = null,
): Promise<OutgosResponse> => {
  if (year && month) {
    return getOutgosWithParams(year, month);
  }

  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get('outgos', options);

  return response.json();
};

export const postOutgo = async (outgo: Outgo): Promise<OutgoResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: {
      outgo,
    },
    throwHttpErrors: true,
  };

  const response = await ky.post('outgos', options);

  return response.json();
};

export const patchOutgo = async (outgo: Outgo): Promise<OutgoResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: {
      outgo,
    },
    throwHttpErrors: true,
  };

  const response = await ky.patch(`outgos/${outgo.id}`, options);

  return response.json();
};

export const deleteOutgo = async (outgo: Outgo): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(`outgos/${outgo.id}`, options);

  return response.json();
};
